<template>
    <div>
        <div class="flex justify-end sm:justify-between items-center mb-6">
            <p class="text-xl font-semibold d-none d-sm-block">Danh sách người dùng</p>
            <button @click="createAction" class="admin-create-btn">
                <i class='bx bx-plus-circle text-white my-auto' ></i><p>Thêm mới</p>
            </button>
        </div>
        <template>
            <CTable class="!mb-1">
                <template slot="thead">
                    <th scope="col">STT</th>
                    <th scope="col">Ảnh</th>
                    <th scope="col">Tên tài khoản</th>
                    <th scope="col">Số điện thoại</th>
                    <th scope="col">Email</th>
                    <th scope="col"></th>
                </template>
                <template slot="tbody">
                    <tr v-for="(entry, index) in entries" :key="index">
                        <td class="cell-sm my-auto">{{ (($route.query.page ? $route.query.page : 1) - 1)*itemsPerPage + index + 1 }}</td>
                        <td class="cell-md cursor-pointer">
                            <img class="w-full h-[35px] object-cover" :src="$addPrefix(entry.image)" alt @error="replaceBrokenImage">
                        </td>
                        <td class="min-w-[120px]">{{ entry.name }}</td>
                        <td class="min-w-[120px]">{{ entry.phone }}</td>
                        <td class="min-w-[200px]">{{ entry.email }}</td>
                        <td class="w-[100px]">
                            <TableActions
                                :canEdit="true" @editAction="editEntry(entry)"
                                :canDelete="true" @deleteAction="deleteEntry(entry)"
                            />
                        </td>
                    </tr>
                </template>
            </CTable>
        </template>
        <Pagination v-if="rawData.length > itemsPerPage" :totalItems="rawData.length" :itemsPerPage="itemsPerPage" />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import list from "@/mixins/list";
import CTable from "@/components/tabledata/customTable"
import Pagination from "@/components/tabledata/table-pagination"
import TableActions from "@/components/tabledata/tableActions"
export default {
    name: 'list',
    mixins: [list],
    components: {
        CTable, TableActions, Pagination
    },
    data() {
        return {}
    },
    methods: {
        ...mapActions('user', ['GetUserList', 'DeleteUser']),
        async getEntry() {
            let response = await this.GetUserList()
            this.rawData = await response.data
            this.splitItemsPerPage()
        },
        deleteEntry(entry) {
            this.$swal.fire({
                title: 'Bạn chắc chắn muốn xóa chứ?',
                text: "",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Xóa!',
                cancelButtonText: 'Hủy'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await this.DeleteUser(entry)
                    this.getEntry()
                    this.$swal.fire(
                        'Xóa thành công!',
                        '',
                        'success'
                    )
                }
            })
        }, 
    },
}
</script>